import { AdvancedFilterButton } from '@/components/common/AdvancedFilter';
import { SearchInput } from '@/components/common/SearchInput';
import { PageTitle } from '@/components/layout/PageTitle';
import { PageToolbar } from '@/components/layout/PageToolbar';
import type { MoTravelListSearchState } from '../hooks/useMoTravelListSearch';
import { useNameSearchText } from '../hooks/useNameSearchText';
import { getBangladeshToday } from '../utils/bangladeshClock';
import { MapOnSwitch } from './MapOnSwitch';
import { MoPeriodDatePicker } from './MoPeriodDatePicker';

const MO_TRAVEL_LIST_TITLE = 'MO Travel History';

interface MoTravelListHeaderProps {
  searchState: MoTravelListSearchState;
  isFilterOpen: boolean;
  onFilterToggle: () => void;
}

export function MoTravelListHeader({
  searchState,
  isFilterOpen,
  onFilterToggle,
}: MoTravelListHeaderProps) {
  const { search, activeFilterCount, handleNameSearch, handlePeriodChange } = searchState;
  const [nameText, setNameText] = useNameSearchText(search.fullName, handleNameSearch);

  return (
    <div className="flex flex-col gap-3">
      <PageTitle>{MO_TRAVEL_LIST_TITLE}</PageTitle>
      <PageToolbar currentTitle={MO_TRAVEL_LIST_TITLE}>
        <div className="flex flex-col gap-2 sm:flex-row sm:flex-wrap sm:items-center sm:justify-end">
          <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
            <MapOnSwitch value={search.mapOn} onChange={(mapOn) => handlePeriodChange({ mapOn })} />
            <MoPeriodDatePicker
              date={search.date}
              mapOn={search.mapOn}
              maxDate={getBangladeshToday()}
              onDateChange={(date) => handlePeriodChange({ date })}
              className="sm:min-w-48 sm:shrink-0"
            />
          </div>
          <div className="flex items-center gap-2 sm:flex-1 lg:flex-none">
            <SearchInput
              value={nameText}
              onChange={setNameText}
              placeholder="Search MO by name"
              className="min-w-0 sm:min-w-48"
            />
            <AdvancedFilterButton
              isOpen={isFilterOpen}
              activeCount={activeFilterCount}
              onClick={onFilterToggle}
            />
          </div>
        </div>
      </PageToolbar>
    </div>
  );
}
